import { ApolloClient, InMemoryCache, createHttpLink, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const API_URL = process.env.REACT_APP_API_URL || "http://18.223.50.152:8005";

// Use WS_URL from env if available, otherwise derive it from API_URL
const rawWsUrl = process.env.REACT_APP_WS_URL || API_URL.replace(/^http/, 'ws');
const WS_URL = rawWsUrl.endsWith('/graphql') ? rawWsUrl : `${rawWsUrl}/graphql`;

const httpLink = createHttpLink({
  uri: API_URL.endsWith('/graphql') ? API_URL : `${API_URL}/graphql`,
});

const wsLink = new GraphQLWsLink(createClient({
  url: WS_URL,
  connectionParams: () => {
    const token = localStorage.getItem('token');
    return {
      authorization: token ? `Bearer ${token}` : "",
    };
  },
}));

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

// Split traffic: subscriptions go over WebSocket, everything else over HTTP
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  authLink.concat(httpLink),
);

export const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
